<template>
  <div>
    <BreadCrumb PageTitle="Wholesale Customers List" />
    <WholesaleCustomersList />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import WholesaleCustomersList from "../../components/Wholesale/WholesaleCustomersList.vue";

export default defineComponent({
  name: "WholesaleCustomersListPage",
  components: {
    BreadCrumb,
    WholesaleCustomersList,
  },
});
</script>